import { noPreferenceReducedMotion } from '../../functions/reducedMotion';
(function () {
    const startPageBgSVG = document.querySelector('#start-page-bg > svg');
    if (!startPageBgSVG)
        return;
    if (!noPreferenceReducedMotion)
        return;
    import('gsap').then(({ gsap }) => {
        import('gsap/ScrollTrigger').then(({ ScrollTrigger }) => {
            gsap.registerPlugin(ScrollTrigger);
            const trigger = {
                start: 0,
                end: 400,
                scrub: 1,
                invalidateOnRefresh: true,
            };
            if (noPreferenceReducedMotion) {
                gsap.to(startPageBgSVG, {
                    y: 150,
                    ease: 'none',
                    scrollTrigger: trigger,
                });
            }
        });
    });
})();
//# sourceMappingURL=start-page-bg.js.map